// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import moment from 'moment';
import styles from './styles';


class VoucherInfo extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    voucher: PropTypes.object,
  };

  static defaultProps = {
    classes: {},
    voucher: {},
  };

  getDate = (date) => {
    // Spelled out rather than moment's 'L', which follows the active locale
    // and so rendered 09/14/2026 for a voucher issued on the 14th.
    return moment(date).format('DD/MM/YYYY');
  };

  render() {
    const {
      classes,
      voucher,
    } = this.props;

    return (
      <div className={classes.container}>
        <div className={classes.column}>
          <div className={classes.row}>
            <p className={classes.staticText}>Code:&nbsp;</p>
            <p className={classes.text}>{`${voucher.Code}`}</p>
          </div>
          <div className={classes.row}>
            <p className={classes.staticText}>Value:&nbsp;</p>
            <p className={classes.text}>{`${parseFloat(voucher.IssueValue).toFixed(2)}`}</p>
          </div>
        </div>
        <div className={classes.column}>
          <div className={classes.row}>
            <p className={classes.staticText}>Date:&nbsp;</p>
            <p className={classes.text}>{`${this.getDate(voucher.IssueDate)}`}</p>
          </div>
          <div className={classes.row}>
            <p className={classes.staticText}>Order no:&nbsp;</p>
            <p className={classes.text}>{`${voucher.OrderId}`}</p>
          </div>
        </div>
      </div>
    );
  }
}

export default (withStyles(styles)(VoucherInfo));
